const customerProps = [
  'customerCreationDate',
  'commercial',
  'resellerId',
  'uniqueCode',
  'buildingId',
  'address',
  'apartmentNumber',
  'firstName',
  'lastName',
  'primaryEmail',
  'alternativeEmail',
  'phoneMobile',
  'phoneWork',
  'postCode'
]

export function getCustomerDetailsToSave (sourceData) {
  const res = Object.assign({}, ...customerProps.map(key => ({ [key]: sourceData ? sourceData[key] : this[key] })))
  return this._id ? Object.assign(res, { _id: this._id }) : res
}
